// src/scenes/BootScene.js
// ─────────────────────────────────────────────────────────────────────────────
// First scene to run — renders entirely with Phaser graphics (no asset load
// needed) so the screen is never blank. Preloads TitleScene heavy assets
// (logo, background, music) then fades into TitleScene.
// ─────────────────────────────────────────────────────────────────────────────

import Phaser        from "phaser";
import logoImg       from "../assets/logo/pazuromonlogojap1.png";
import bgImg         from "../assets/backgrounds/main_screen_background.png";
import titleMusicUrl from "../assets/audio/music/pazurumon_main_title.ogg";
import plicaLogoImg  from "../assets/plicameslogo/plicagamessembg.png";

export default class BootScene extends Phaser.Scene {
  constructor() { super("BootScene"); }

  preload() {
    const W = this.scale.width;
    const H = this.scale.height;

    // ── Dark canvas fill ──────────────────────────────────────────────────────
    this.add.rectangle(W / 2, H / 2, W, H, 0x0b0f14);

    // ── Branding ──────────────────────────────────────────────────────────────
    this.add.text(W / 2, H * 0.18, "PAZURUMON", {
      fontFamily: "Kamikaze, system-ui, Arial",
      fontSize:   "58px",
      color:      "#ffffff",
      stroke:     "#000000",
      strokeThickness: 5,
    }).setOrigin(0.5);

    this.add.text(W / 2, H * 0.18 + 62, "CHALLENGE", {
      fontFamily: "Kamikaze, system-ui, Arial",
      fontSize:   "26px",
      color:      "#fbbf24",
      stroke:     "#000000",
      strokeThickness: 3,
    }).setOrigin(0.5);

    // ── Plicagames logo ───────────────────────────────────────────────────────
    this.load.image("plica-logo", plicaLogoImg);
    this.load.once("filecomplete-image-plica-logo", () => {
      const logo = this.add.image(W / 2, H * 0.50, "plica-logo");
      const scale = (W * 0.45) / logo.width;
      logo.setScale(scale).setOrigin(0.5);
    });

    this.add.text(W / 2, H * 0.50 + 56, "Presents", {
      fontFamily: "system-ui, Arial",
      fontSize:   "13px",
      color:      "#94a3b8",
      fontStyle:  "italic",
    }).setOrigin(0.5);

    // ── Progress bar ──────────────────────────────────────────────────────────
    const BAR_W = W * 0.55;
    const BAR_Y = H * 0.64;

    this.add.rectangle(W / 2, BAR_Y, BAR_W, 3, 0x1e293b);
    const barFill = this.add
      .rectangle(W / 2 - BAR_W / 2, BAR_Y, 1, 3, 0xfbbf24)
      .setOrigin(0, 0.5);

    this.add.text(W / 2, BAR_Y + 18, "A carregar…", {
      fontFamily: "system-ui, Arial",
      fontSize:   "11px",
      color:      "#334155",
    }).setOrigin(0.5);

    // ── Preload TitleScene assets (same keys — Phaser skips if already cached)
    this.load.image("title-logo", logoImg);
    this.load.image("title-bg",   bgImg);
    this.load.audio("bgm_title",  titleMusicUrl);

    this.load.on("progress", v => {
      barFill.width = Math.max(1, BAR_W * v);
    });
  }

  create() {
    this.cameras.main.fadeOut(280, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("TitleScene");
    });
  }
}
